module.exports = __webpack_public_path__ + "static/img/headset.4c4affa7.svg";